import { AUDIT_TYPE_LABELS, type Audit } from "@/services/api/guardiansv2/types";
import type { ScopeLabelCache } from "./useScopeLabelCache";

function shortId(id: string): string {
  return id.length > 10 ? `${id.slice(0, 8)}…` : id;
}

/** Human label for the audited entity row in the inspector. */
export function getAuditedEntityLabel(
  audit: Audit,
  scopeLabels: ScopeLabelCache
): string {
  const { audit_type, subject, scope, inputs } = audit;
  const summary = inputs?.summary?.trim();

  switch (audit_type) {
    case "task_complete": {
      const taskLabel = scopeLabels.taskLabel(scope.task_id);
      if (taskLabel) return taskLabel;
      return summary || `Task ${shortId(String(subject.id))}`;
    }
    case "interaction":
      return summary || `Interaction ${shortId(String(subject.id))}`;
    case "mission_complete": {
      const missionLabel = scopeLabels.missionLabel(scope.mission_id);
      if (missionLabel) return missionLabel;
      return summary || `Mission ${shortId(String(subject.id))}`;
    }
    case "artifact":
      return summary || `Artifact ${shortId(String(subject.id))}`;
    case "tool_call": {
      const tools = inputs?.tool_names;
      if (tools?.length) return `Tool: ${tools.join(", ")}`;
      return `Tool call (step ${subject.version ?? "?"})`;
    }
    case "trigger_run":
      return summary || `Trigger ${shortId(String(subject.id))}`;
    default:
      return summary || AUDIT_TYPE_LABELS[audit_type] || String(subject.id);
  }
}

/** Row label for the audited entity (Task, Interaction, …). */
export function getAuditedEntityRowLabel(audit: Audit): string {
  return AUDIT_TYPE_LABELS[audit.audit_type] ?? "Entity";
}
